"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYC = _interopRequireDefault(require("../KYC"));
var _KYCSumSubLevelsContainer = _interopRequireDefault(require("./KYCSumSubLevelsContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYCSumSubComponent = function KYCSumSubComponent() {
  return /*#__PURE__*/_react["default"].createElement(_KYC["default"], {
    LevelsComponent: _KYCSumSubLevelsContainer["default"]
  });
};
var _default = exports["default"] = KYCSumSubComponent;